import React from 'react'

function Splash() {
  return (
    <div>Loading...</div>
  )
}

export default Splash